import type { EditorElement } from '@wix/component-protocol/schema';
import type { CompRef } from '@wix/document-services-types';
import type { ContainerPlatformService } from '../../componentsPlatformServices';
import type { EditorPointer } from '@wix/editor-document-logic-api';

export abstract class AbstractInternalContainerOverride {
  #containerPlatformService: ContainerPlatformService;

  constructor(containerPlatformService: ContainerPlatformService) {
    this.#containerPlatformService = containerPlatformService;
  }

  protected get containerPlatformService(): ContainerPlatformService {
    return this.#containerPlatformService;
  }

  abstract resolve(
    editorPointer: EditorPointer<CompRef>,
    containerOwnerPointer: EditorPointer<CompRef>,
    editorElement: EditorElement,
  ): EditorElement | null;
}
